export default "__VITE_ASSET__DkwRRlra__"